export class StringHelper {
  public static sentenceCase(
    str: string,
    removeSymbols: boolean = false
  ): string {
    if (str.length === 0 || !str) {
      return '';
    }
    const sentence = str.charAt(0).toUpperCase() + str.slice(1);

    if (removeSymbols) {
      return sentence.replace(/[^a-zA-Z0-9\s]/g, ' ').trim();
    }

    return sentence;
  }

  public static kababCase(str: string): string {
    if (str.length === 0 || !str) {
      return '';
    }

    return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
  }
}
